import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  initialize() {
    this.update = this.update.bind(this)
  }

  connect() {
    window.addEventListener("scroll", this.update, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.update)
  }

  scroll(event) {
    event.preventDefault()
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  update() {
    this.element.classList.toggle("visible", window.scrollY > 300)
  }
}
